
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import AILawEthics from './pages/AILawEthics';
import Brochures from './pages/Brochures';
import AdminBrochures from './pages/AdminBrochures';
import CorporateGovernanceTech from './pages/CorporateGovernanceTech';
import ArbitrationADR from './pages/ArbitrationADR';
import FounderProfile from './pages/FounderProfile';
import Mentorship from './pages/Mentorship';
import Contact from './pages/Contact';
import MentorshipApplication from './pages/MentorshipApplication';
import PrivacyPolicy from './pages/PrivacyPolicy';
import MachineLearning from './pages/sectors/MachineLearning';
import AgenticAI from './pages/sectors/AgenticAI';
import GenerativeAI from './pages/sectors/GenerativeAI';
import ComputerVision from './pages/sectors/ComputerVision';
import NLPPrivacy from './pages/sectors/NLPPrivacy';
import RoboticsLegal from './pages/sectors/RoboticsLegal';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navigation />
        
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/ai-law-ethics" element={<AILawEthics />} />
            <Route path="/brochures" element={<Brochures />} />
            <Route path="/admin/brochures" element={<AdminBrochures />} />
            <Route path="/corporate-governance-tech" element={<CorporateGovernanceTech />} />
            <Route path="/arbitration-adr" element={<ArbitrationADR />} />
            <Route path="/founder-profile" element={<FounderProfile />} />
            <Route path="/mentorship" element={<Mentorship />} />
            <Route path="/mentorship-application" element={<MentorshipApplication />} />
            <Route path="/sectors/machine-learning" element={<MachineLearning />} />
            <Route path="/sectors/agentic-ai" element={<AgenticAI />} />
            <Route path="/sectors/generative-ai" element={<GenerativeAI />} />
            <Route path="/sectors/computer-vision" element={<ComputerVision />} />
            <Route path="/sectors/nlp-privacy" element={<NLPPrivacy />} />
            <Route path="/sectors/robotics-legal" element={<RoboticsLegal />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
